import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AritoIcon } from '@/components/custom/arito';

interface AritoConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const AritoConfirmModal: React.FC<AritoConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Cảnh báo',
  message,
  confirmText = 'Đồng ý',
  cancelText = 'Hủy'
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, open]);

  if (!mounted || !open) return null;

  return createPortal(
    <div
      aria-modal='true'
      className='fixed inset-0 z-[1300] flex items-center justify-center bg-transparent'
      role='dialog'
    >
      <div className='w-full max-w-[600px] overflow-hidden bg-[#f8fcfd] shadow-lg'>
        <div className='flex h-9 items-center justify-between border-b border-[#e0e0e0] bg-[#f0f7fc]'>
          <div className='ml-2 flex items-center gap-1'>
            <AritoIcon icon={260} marginX='4px' />
            <span className='text-sm text-[#444]'>{title}</span>
          </div>
          <button
            className='flex h-full items-center px-2.5 text-black hover:bg-[#d9e6ed]'
            onClick={onClose}
            type='button'
          >
            <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-3' />
          </button>
        </div>

        <div className='p-0'>
          <p className='mb-2 px-5 py-2.5 text-xs'>{message}</p>

          <div className='h-px bg-border' />

          <div className='flex justify-end gap-2 p-1.5'>
            <button
              className='flex w-[100px] cursor-default items-center justify-center gap-1 bg-[#53a3a3] px-1.5 py-1.5 pr-3 text-sm text-white transition-colors hover:bg-[#438585]'
              onClick={onConfirm}
              type='button'
            >
              <AritoIcon icon={884} marginX='4px' />
              {confirmText}
            </button>

            <button
              className='flex w-[100px] cursor-default items-center justify-center gap-1 border border-[#53a3a3] bg-white px-1.5 py-1.5 pr-3 text-sm text-[#53a3a3] transition-colors hover:bg-[#53a3a3] hover:text-white'
              onClick={onClose}
              type='button'
            >
              <AritoIcon icon={885} marginX='4px' />
              {cancelText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AritoConfirmModal;
